// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const icon: Styleguide["icon"] = {};

export default icon;
